import { default as cx } from "classnames"
export function RadioButtonAnswer({
    field,
    handle,
    options,
    includeNA,
    naValue,
    data,
    emptyError,
}) {
    return (
        <>
            <div className="d-flex flex-row flex-center flex-md-stack gap-2">
                {options.map((option, index) => {
                    const id = `${field}-${index}`
                    const checked = option.value === data
                    return (
                        <div className="flex-fill" key={index}>
                            <input
                                id={id}
                                type="radio"
                                className="btn-check"
                                name={field}
                                value={option.value}
                                checked={checked}
                                onChange={(evt) => handle(evt.target.value)}
                            />
                            <label
                                className={cx(
                                    "btn btn-outline btn-active-primary btn-flex flex-center w-100",
                                    {
                                        active: checked,
                                        "border-danger": emptyError,
                                    },
                                )}
                                htmlFor={id}
                            >
                                {option.label}
                            </label>
                        </div>
                    )
                })}
            </div>
            {includeNA && (
                <div className="d-flex flex-row flex-center flex-md-stack pt-6">
                    <input
                        type="radio"
                        className="btn-check"
                        name={field}
                        value={naValue}
                        id={`${field}-na`}
                        onChange={(evt) => handle(evt.target.value)}
                        checked={data === naValue}
                    />
                    <label
                        className={cx(
                            "btn btn-outline btn-active-primary btn-flex flex-center w-100",
                            {
                                active: data === naValue,
                                "border-danger": emptyError,
                            },
                        )}
                        htmlFor={`${field}-na`}
                    >
                        Not Applicable
                    </label>
                </div>
            )}
        </>
    )
}
